/**
 * TSS logs Admin API
 * TSS logs Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantTssConfigBodyDTO { 
    disabledTssLogExpiration?: boolean;
    postponedRemovalAcknowledgedLogs?: number;
}

export class ClsTenantTssConfigBodyDTO { 
    disabledTssLogExpiration?: boolean = undefined;
    postponedRemovalAcknowledgedLogs?: number = undefined;
}

